import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import { Avatar, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { GlobalContext } from '../../GlobalContext';
import { ProjectContext } from '../../projects/project.context';
import { UserContext } from '../../user/user.context';
import Logo from '../logo';

const Navbar = () => {
  const { user } = useContext(UserContext);
  const { project, botTab } = useContext(ProjectContext);
  const {
    activeFlowName,
    resetFlowName,
    toggleActiveChannelNameStatistic,
    activeChannelNameStatistic,
  } = useContext(GlobalContext);

  const navigate = useNavigate();

  const goToHomepage = () => {
    navigate('/');
    localStorage.removeItem('projectId');
    localStorage.removeItem('bot');
    localStorage.removeItem('channelId');
    localStorage.removeItem('channelTabIndex');
    localStorage.removeItem('currentDialog');
    localStorage.removeItem('tabIndexMessenger');
    localStorage.removeItem('tabIndex');
    toggleActiveChannelNameStatistic('');
    resetFlowName();
  };

  const goToDocumentation = () => {
    window.open(
      'https://axioma-bot-documentation.notion.site/6c173eb393ec4af49fc29c89a132fdf5?v=d18d125e7e9e49f38d57b9d50d3a4c42&pvs=4',
    );
  };

  const goToHomePage = () => {
    if (!project) return;
    navigate(`/project/${project._id}/main`);
  };

  const goToUserEdit = () => {
    navigate('/user');
  };

  useEffect(() => {
    if (botTab !== 'flows' && botTab !== undefined) {
      resetFlowName();
      sessionStorage.removeItem('flowId');
    }
    if (botTab !== 'statistics') {
      toggleActiveChannelNameStatistic('');
    }
  }, [botTab]);

  if (!user) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        width: '100%',
        height: '70px',
        padding: '10px  24px',
        backgroundColor: 'grey.14',
        borderBottom: '1px solid',
        borderColor: 'grey.13',
      }}
    >
      <Stack flexDirection="row" gap="20px">
        <Logo width={105} onClick={goToHomepage} />
        <Stack
          sx={{ width: '1px', height: '100%', backgroundColor: 'grey.13' }}
        />
        {project && (
          <Stack
            justifyContent="center"
            alignItems="center"
            flexDirection="row"
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '18px',
              }}
            >
              {t('common.project')}:{' '}
              <Typography
                component="span"
                sx={{ color: 'green.3', fontWeight: 500, fontSize: '18px' }}
              >
                {project.name}
              </Typography>
            </Typography>
            {activeFlowName && (
              <Stack sx={{ ml: '32px' }}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '18px',
                  }}
                >
                  {t('common.flow')}:{' '}
                  <Typography
                    component="span"
                    sx={{ color: 'green.3', fontWeight: 500, fontSize: '18px' }}
                  >
                    {activeFlowName}
                  </Typography>
                </Typography>
              </Stack>
            )}
            {activeChannelNameStatistic && (
              <Stack sx={{ ml: '32px' }}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '18px',
                  }}
                >
                  {t('common.channel')}:{' '}
                  <Typography
                    component="span"
                    sx={{ color: 'green.3', fontWeight: 500, fontSize: '18px' }}
                  >
                    {activeChannelNameStatistic}
                  </Typography>
                </Typography>
              </Stack>
            )}
          </Stack>
        )}
      </Stack>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap="16px"
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: '50px',
            height: '50px',
            backgroundColor: 'grey.10',
            borderRadius: '39px',
            color: 'green.2',
            cursor: 'pointer',
          }}
          onClick={goToDocumentation}
        >
          <svg
            width="22"
            height="28"
            viewBox="0 0 22 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.325 6.00833L15.4917 0.175C15.384 0.0650917 15.2372 0.00219161 15.0833 0L2.83333 0C2.21449 0 1.621 0.245833 1.18342 0.683417C0.745833 1.121 0.5 1.71449 0.5 2.33333V25.6667C0.5 26.2855 0.745833 26.879 1.18342 27.3166C1.621 27.7542 2.21449 28 2.83333 28H19.1667C19.7855 28 20.379 27.7542 20.8166 27.3166C21.2542 26.879 21.5 26.2855 21.5 25.6667V6.41667C21.4978 6.2628 21.4349 6.11603 21.325 6.00833ZM11.5833 23.3333H5.75C5.59529 23.3333 5.44692 23.2719 5.33752 23.1625C5.22812 23.0531 5.16667 22.9047 5.16667 22.75C5.16667 22.5953 5.22812 22.4469 5.33752 22.3375C5.44692 22.2281 5.59529 22.1667 5.75 22.1667H11.5833C11.738 22.1667 11.8864 22.2281 11.9958 22.3375C12.1052 22.4469 12.1667 22.5953 12.1667 22.75C12.1667 22.9047 12.1052 23.0531 11.9958 23.1625C11.8864 23.2719 11.738 23.3333 11.5833 23.3333ZM16.25 19.8333H5.75C5.59529 19.8333 5.44692 19.7719 5.33752 19.6625C5.22812 19.5531 5.16667 19.4047 5.16667 19.25C5.16667 19.0953 5.22812 18.9469 5.33752 18.8375C5.44692 18.7281 5.59529 18.6667 5.75 18.6667H16.25C16.4047 18.6667 16.5531 18.7281 16.6625 18.8375C16.7719 18.9469 16.8333 19.0953 16.8333 19.25C16.8333 19.4047 16.7719 19.5531 16.6625 19.6625C16.5531 19.7719 16.4047 19.8333 16.25 19.8333ZM16.25 16.3333H5.75C5.59529 16.3333 5.44692 16.2719 5.33752 16.1625C5.22812 16.0531 5.16667 15.9047 5.16667 15.75C5.16667 15.5953 5.22812 15.4469 5.33752 15.3375C5.44692 15.2281 5.59529 15.1667 5.75 15.1667H16.25C16.4047 15.1667 16.5531 15.2281 16.6625 15.3375C16.7719 15.4469 16.8333 15.5953 16.8333 15.75C16.8333 15.9047 16.7719 16.0531 16.6625 16.1625C16.5531 16.2719 16.4047 16.3333 16.25 16.3333ZM16.25 12.8333H5.75C5.59529 12.8333 5.44692 12.7719 5.33752 12.6625C5.22812 12.5531 5.16667 12.4047 5.16667 12.25C5.16667 12.0953 5.22812 11.9469 5.33752 11.8375C5.44692 11.7281 5.59529 11.6667 5.75 11.6667H16.25C16.4047 11.6667 16.5531 11.7281 16.6625 11.8375C16.7719 11.9469 16.8333 12.0953 16.8333 12.25C16.8333 12.4047 16.7719 12.5531 16.6625 12.6625C16.5531 12.7719 16.4047 12.8333 16.25 12.8333ZM16.8333 5.83333C16.5239 5.83333 16.2272 5.71042 16.0084 5.49162C15.7896 5.27283 15.6667 4.97609 15.6667 4.66667V1.995L19.505 5.83333H16.8333Z"
              fill="#CAFA44"
            />
          </svg>
        </Stack>
        {project && (
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              width: '50px',
              height: '50px',
              backgroundColor: 'grey.10',
              borderRadius: '39px',
              color: 'green.2',
              cursor: 'pointer',
            }}
            onClick={goToHomePage}
          >
            <TrendingUpRoundedIcon />
          </Stack>
        )}
        <Avatar
          sx={{
            width: '50px',
            height: '50px',
            backgroundColor: 'grey.10',
            color: 'green.2',
            cursor: 'pointer',
          }}
          src={user.avatarUrl}
          onClick={goToUserEdit}
        />
      </Stack>
    </Stack>
  );
};

export default Navbar;
